import type { Capture, Color, Move } from '@draughts/shared';

/**
 * Returns the list of captured pieces of a given color across the whole
 * move history, in chronological order (oldest first). Useful to render
 * "pieces opponent has taken from you" / "pieces you have taken from
 * opponent" on the player cards.
 */
export function getCapturedByColor(moveHistory: Move[], color: Color): Capture[] {
  const out: Capture[] = [];
  for (const move of moveHistory) {
    for (const capture of move.captures) {
      if (capture.piece.color === color) out.push(capture);
    }
  }
  return out;
}
